import { apiService } from './apiService';

export function getItemAttributeService(data) {
    return apiService({
        method: 'POST',
        url: '/item-attribute/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdItemAttributeService(id) {
    return apiService({
        method: 'GET',
        url: '/item-attribute/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addItemAttributeService(data) {
    return apiService({
        method: 'POST',
        url: '/item-attribute',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateItemAttributeService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/item-attribute/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteItemAttributeService(id) {
    return apiService({
        method: 'DELETE',
        url: '/item-attribute/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
